<template>
  <div class="hvh-share-cohort">
    <p>{{ instructionalText }}</p>
    <form action>
      <InputCheckbox color="#11697d" :value="selectAllChecked" @input="checkAllUsers" :class="{ 'hvh-disabled': users.length === 0 }">Share with entire organization {{ users.length }} users)</InputCheckbox>
      <v-text-field outline :append-icon="filterText ? 'mdi-close' : 'mdi-magnify'" v-model="filterText" @click:append="filterText = ''" label="Search for individual users..."></v-text-field>
      <v-list class="hvh-share-cohort__list">
        <template v-if="filteredUserList.length">
          <v-list-tile v-for="user in filteredUserList" :key="user.id" class="mx-3" :class="{ 'hvh-disabled': user.isAdmin }">
            <v-list-tile-action class="hvh-share-cohort__list__checkbox">
              <InputCheckbox v-model="user.selected" @input="user.halfChecked = false" :color="user.halfChecked ? 'grey' : '#11697d'">
                <v-list-tile-content>
                  <template v-if="user.name">
                    <v-list-tile-title>{{ user.name }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
                  </template>
                  <v-list-tile-title v-else>{{ user.email }}</v-list-tile-title>
                </v-list-tile-content>
              </InputCheckbox>
            </v-list-tile-action>
            <v-list-tile-action class="hvh-share-cohort__list__access__wrapper">
              <v-select :items="accessLevelsForUser(user)" v-bind:value="accessLevels[user.access - 1]" @change="user.access = accessLevels.indexOf($event) + 1" outline class="hvh-share-cohort__list__access" :disabled="!user.selected"></v-select>
            </v-list-tile-action>
          </v-list-tile>
        </template>
        <div class="mx-3" v-else>
          <div class="hvh-no-items">No items to show.</div>
        </div>
      </v-list>
    </form>
  </div>
</template>

<script>
import InputCheckbox from '../common/form/inputCheckbox/HvhInputCheckbox';

export default {
  components: { InputCheckbox },

  props: ['instructionalText', 'users'],
  data() {
    return {
      filterText: '',
    };
  },
  computed: {
    userList() {
      const list = this.users.map((item) => {
        item.accessLevel = 'readonly';
        item.selected = false;
        return item;
      });

      return list;
    },
    accessLevels() {
      return ['Read/Write access', 'Read only access'];
    },
    selectAllChecked() {
      return (
        this.users.length &&
        this.users.filter((f) => f.selected).length === this.users.length
      );
    },
    filteredUserList() {
      if (!this.filterText) {
        return this.users;
      }

      return this.users.filter(
        (f) =>
          f.email.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 ||
          (f.name && f.name.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0)
      );
    },
  },
  methods: {
    accessLevelsForUser(user) {
      return this.accessLevels.filter((_, ind) => ind >= user.maxRight - 1);
    },
    checkAllUsers(event) {
      this.users
        .filter((f) => event || !f.isAdmin)
        .forEach((f) => {
          this.$set(f, 'selected', event);
          this.$set(f, 'halfChecked', false);
        });
    },
  },
};
</script>

<style lang="scss">
.hvh-share-cohort {
  .v-list__tile {
    border-bottom: 1px solid $color-gray-1;
    padding: rem(12px) rem(10px);
    height: auto;
  }
}

.hvh-share-cohort__list {
  max-height: rem(250px);
  border-radius: 4px;
  border: 1px solid $color-gray-2;
  overflow: auto;
}

.hvh-share-cohort__list__checkbox {
  min-width: 0;
  margin-right: rem(14px);
}

.hvh-share-cohort__list__access__wrapper {
  margin-left: auto;
}

.hvh-share-cohort__list__access {
  flex: 1 1 175px;
  max-width: 175px;

  &.v-text-field--enclosed:not(.v-text-field--single-line) {
    .v-input__control {
      .v-input__slot {
        min-height: 0;
        width: auto;
      }
    }

    .v-select__selections {
      padding-top: 0;
    }

    .v-input__append-inner {
      margin-top: 3px;
      margin-right: -12px;
    }

    .v-text-field__details,
    .v-messages {
      min-height: 0;
      margin: 0;
    }
  }

  .v-select__selection {
    font-size: rem(14px);
    margin: 0;
    max-width: none;
    width: 100%;
  }
}

.hvh-no-items {
  padding: rem(12px) rem(10px);
}

.hvh-disabled {
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
}
</style>
